module.exports = __webpack_public_path__ + "img/c00_buildingtechnetweights_Normal_ua.3b5b87e3.webp";